// src/App.js
import React from 'react';
import { ConfigProvider, Layout, Typography, Card, Badge, Space, Row, Col } from 'antd';
import { 
  ThunderboltOutlined, 
  GlobalOutlined, 
  RocketOutlined,
  CheckCircleOutlined 
} from '@ant-design/icons';
import VoiceWidget from './components/VoiceWidget';
import './App.css';

const { Content } = Layout;
const { Title, Paragraph, Text, Link } = Typography;

function App() {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#1890ff',
        },
      }}
    >
        
        
        {/* Voice Widget - Fixed Position */}
        <VoiceWidget />
        
    </ConfigProvider>
  );
}

export default App;
